
import VueApp from '@/@types/app/VueApp';

export default class EmptyCommentCard extends VueApp {}
